module.exports = __webpack_public_path__ + "img/society.9fcde3d2.jpg";